import * as React from 'react';

const ChevronRight24: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
		<path
			d='M10 6L15.8795 11.7173C15.9177 11.7544 15.948 11.7985 15.9687 11.847C15.9894 11.8955 16 11.9475 16 12C16 12.0525 15.9894 12.1045 15.9687 12.153C15.948 12.2015 15.9177 12.2456 15.8795 12.2827L10 18'
			stroke='black'
			stroke-width='1.5'
			stroke-linecap='round'
			stroke-linejoin='round'
		/>
	</svg>
);

export default ChevronRight24;
